import { Controller } from "@hotwired/stimulus"
import { create_simple_modal } from "../simple-modal"
import * as bootstrap from "bootstrap"

// Connects to data-controller="facebox"
export default class extends Controller {
  static values = { modalSize: String }

  modalElement = null;

  connect() {
  }

  showImg(event) {
    event.preventDefault();
    event.stopPropagation();

    // Create an image element with the event.target.href as the src
    const img = document.createElement('img');
    img.src = this.element.href;
    img.className = 'img-fluid';
    const title = this.element.getAttribute('title');
    let header = null;
    if (title) {
      img.alt = title;
      header = title;
    }
    this.createModal(this.element, img, header);
  }

  // The element is a link, and the href is the #id of the div to show.
  // The div to show is hidden by default.  We need to copy the contents
  // of the div to the modal, pull out the header, and then show the modal.
  showDiv(event) {
    event.preventDefault();
    event.stopPropagation();

    const div = document.querySelector(this.element.getAttribute('href')).cloneNode(true);
    div.id = '';
    div.style.display = '';
    const header_el = div.querySelector('h1, h2, h3, h4, h5, h6');
    let header = null;
    if (header_el) {
      header = header_el.innerText;
    }
    this.createModal(this.element, div, header);
  }

  showLink(event) {
    event.preventDefault();
    event.stopPropagation();

    fetch(this.element.href, {
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then((response) => {
      if (response.ok) {
        return response.text();
      } else {
        throw new Error('Network response was not ok.');
      }
    }).then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      let body = null;
      let header_el = null;
      let header = null;
      if (doc.querySelector('main')) {
        body = doc.querySelector('main');
        header_el = body.querySelector('h1, h2, h3, h4, h5, h6');
        if (header_el) {
          header = header_el.innerText;
        }
      } else if (doc.querySelector('modal-content')) {
        body = doc.querySelector('modal-body');
        header_el = doc.querySelector('modal-header :is(h1, h2, h3, h4, h5, h6)');
        if (header_el) {
          header = header_el.innerText;
        }
      } else {
        body = doc.querySelector('body');
      }
      this.createModal(this.element, body, header);
    }).catch((error) => {
      alert('There has been a problem with your fetch operation: ' + error.message);
    });
  }

  createModal(el, body, header_text) {
    const modal = create_simple_modal(header_text, body);
    modal.id = 'facebox-modal';
    if (this.modalSizeValue) {
      modal.querySelector('.modal-dialog').classList.add(`modal-${this.modalSizeValue}`);
    }
    document.body.appendChild(modal);
    this.modalElement = new bootstrap.Modal(modal);
    this.modalElement.show();

    const _this = this;

    function dispose() {
      _this.modalElement.dispose();
      modal.remove();
      _this.modalElement = null;
      document.removeEventListener('hidden.bs.modal', dispose);
    }

    document.addEventListener('hidden.bs.modal', dispose);
  }

  hideModal() {
    this.modalElement.hide();
  }
}
